import React, {Fragment} from 'react';
import Header from './Header';
import CardRedeemedContent from './CardRedeemedContent';
import Footer from './Footer';

const CardRedeemed = () => {
    return (
        <Fragment>
            <Header />
            <CardRedeemedContent />
            <Footer />
        </Fragment>
    );
}

export default CardRedeemed;